import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=93472694&scoped=true"
import script from "./DetailsPanel.vue?vue&type=script&lang=ts"
export * from "./DetailsPanel.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=93472694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93472694",
  null
  
)

export default component.exports